import React from 'react';
import ReactModal from 'react-modal';
import { Provider, getRootStore } from './models/stores/Root';
import LaunchDarklyProvider from './components/LaunchDarklyProvider';
import ErrorPage from './pages/ErrorPage';
import MasterPage from './pages/MasterPage';
import ErrorBoundary from './components/utility/ErrorBoundary';

ReactModal.setAppElement('#root');

const App: React.FC = () => {
  return (
    <Provider value={getRootStore()}>
      <ErrorBoundary errorPage={<ErrorPage />}>
        <LaunchDarklyProvider>
          <MasterPage />
        </LaunchDarklyProvider>
      </ErrorBoundary>
    </Provider>
  );
};

export default App;
